import { useTRPC } from "../../../../trpc/client";
import { useQuery } from "@tanstack/react-query";
import { FiltersType } from "../types/filters.type";
import {
  mapCreationMethod,
  mapErpSyncStatus,
  mapPaymentMethod,
  mapPaymentSource,
  mapStatus,
} from "../mappers/invoice.mapper";
import { useMemo } from "react";
import { useMerchant } from "../../../../hooks/useMerchant";

export function useFetchInvoices(filters: FiltersType, cursor?: string) {
  const { merchant } = useMerchant();
  const trpc = useTRPC();

  const queryFilters = useMemo(
    () => ({
      id: filters.id && filters.id.trim() !== "" ? filters.id : undefined,
      rentalsMerchantId: merchant?.id ?? "",
      status:
        filters.status && mapStatus[filters.status as keyof typeof mapStatus]
          ? mapStatus[filters.status as keyof typeof mapStatus]
          : undefined,
      contract:
        filters.contract && filters.contract.trim() !== ""
          ? filters.contract
          : undefined,
      customerDocumentNumber:
        filters.customerDocumentNumber &&
        filters.customerDocumentNumber.trim() !== ""
          ? filters.customerDocumentNumber
          : undefined,
      creationMethod:
        filters.creationMethod &&
        mapCreationMethod[
          filters.creationMethod as keyof typeof mapCreationMethod
        ]
          ? mapCreationMethod[
              filters.creationMethod as keyof typeof mapCreationMethod
            ]
          : undefined,
      paymentDateRange: filters.dateRange,
      sendDate: filters.sendDate,
      paymentMethod: filters.paymentMethod
        ? mapPaymentMethod[
            filters.paymentMethod as keyof typeof mapPaymentMethod
          ]
        : undefined,
      paymentSource: filters.paymentSource
        ? mapPaymentSource[
            filters.paymentSource as keyof typeof mapPaymentSource
          ]
        : undefined,
      erpSyncStatus: filters.erpSyncStatus
        ? [
            mapErpSyncStatus[
              filters.erpSyncStatus as keyof typeof mapErpSyncStatus
            ],
          ]
        : undefined,
      rentalPeriod: filters.rentalPeriod,
      cursor,
    }),
    [merchant?.id, filters, cursor]
  );

  const { data, isPending, refetch } = useQuery({
    ...trpc.invoices.list.queryOptions(queryFilters),
    enabled: !!merchant?.id,
    refetchInterval: 120_000,
  });

  const invoices = data?.invoices || [];
  const nextCursor = data?.cursor || undefined;
  const totalItems = invoices.length || 0;

  return {
    invoices,
    nextCursor,
    totalItems,
    isLoading: isPending,
    refetch,
  };
}
